<template>
  <v-navigation-drawer
    class="menuSidebar my-elevation-2 index-5 third navbartext--text"
    :class="{'mobile': menu.isMobile}"
    v-model="menu.menuDrawer"
    :mini-variant="menu.menuMini"
    :absolute="menu.isMobile"
    :hide-overlay="menu.isMobile"
    app
    width="240"
    mini-variant-width="70"
  >
    <v-toolbar flat class="transparent my-2">
      <v-list class="pa-0">
        <v-list-tile avatar>
          <img :src="require('../assets/logo.png')">
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-list class="py-0">
      <v-list-tile :to="home.to">
        <v-list-tile-action>
          <v-icon v-text="home.action" :title="home.title"></v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{ home.title }}</v-list-tile-title>
      </v-list-tile>
      
      <div v-for="(item, key) in menuList">
      
        <v-list-tile 
        v-if="item.to"
        :to="item.to">
          <v-list-tile-action>
            <v-icon v-text="item.action" :title="item.title"></v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      
      
        <v-list-group
          v-else
          class="third"
          :key="key"
          :title="item.title"
          v-model="item.active"
          :append-icon="item.items ? 'keyboard_arrow_down' : ''"
        >
          <v-icon slot="prependIcon" :title="item.title">{{ item.action }}</v-icon>

          <template v-slot:activator>
            <v-list-tile class="tile_no_padding third">
              <v-list-tile-title class="third">{{ item.title }}</v-list-tile-title>            
            </v-list-tile>
          </template>
          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.to"
            exact
          >
            <v-list-tile-action>
              <v-icon v-text="subItem.action" :title="subItem.title"></v-icon>      
            </v-list-tile-action>
            <v-list-tile-title v-text="subItem.title"></v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      
      </div>
      
    </v-list>
    <v-footer inset absolute class="transparent my-3 px-3 text-xs-right" v-if="!menu.isMobile">
      <v-icon class="clicker bodybackground--text mx-auto" @click="menuMini">vertical_split</v-icon>
    </v-footer>
  </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex'
/* const crudIcons = {
  list: 'list',
  add: 'add_circle'
} */

export default {
	data () {
		return {
      showTooltip: false,
      home: {
        action: 'person',
        title: 'Usuarios',
        to: {name:'users'}
      },
      menuList: [
        {
          action: 'confirmation_number',
          title: 'Códigos',
          to: {name:'codigos'}
        },
        {
          action: 'calendar_today',
          title: 'Configuración',
          to: {name:'configuracion'}
        },
        
        // {
        //   action: 'person',
        //   title: 'Usuarios',
        //   items: [
        //     {
        //       title: 'Listar usuarios',
        //       action: crudIcons.list,
        //       to: {name:'users'}
        //     },
        //     {
        //       title: 'Añadir usuario',
        //       action: crudIcons.add,
        //       to: {name:'user', params: { id: 'new' }}
        //     }
        //   ]
        // }
      ]
      
		}
	},
	methods: {
    menuMini() {
      this.$store.commit('toggleMenuMini')
    }
  },
  computed: {
    ...mapState(['menu'])
  }
}
</script>

<style lang="scss">
.clicker {
  cursor: pointer;
}

.menuSidebar {
  min-height: calc(100vh); // 65 del toolbar
  &.mobile {
    min-height: calc(100vh - 125px);
    top: 60px;
    width: 100% !important;
    max-height: calc(100% - 60px);
    position: fixed;
    overflow-y: auto;
    &.v-navigation-drawer--close{
      transform: translateX(-100%) !important;
    }
  }  
}

.v-list__group.v-list__group--active {
  background-color: #f2f2f2;
}

.v-list__tile__action, .v-list__tile__avatar {
  min-width: 38px !important;
}
.v-list__tile--avatar img{
  width: 35px;
}

.tile_no_padding {
  .v-list__tile {
    padding: 0px !important;
  }
}

</style>
